import Swiper, { Lazy, Navigation, Pagination } from "swiper";

// eslint-disable-next-line import/prefer-default-export
export function carousel(config, Alpine) {
  return {
    config: config || {},
    mainSlider: null,
    totalSlides: 0,
    disabled: false,
    init() {
      const vm = this;
      const mainWrapper = vm.$refs.wrapper;
      const swiperMain = new Swiper(mainWrapper, {
        modules: [Navigation, Pagination, Lazy],
        loop: vm.config.loop || false,
        // autoHeight: true, // enable auto height
        initialSlide: 0,
        preloadImages: false,
        watchSlidesProgress: true,
        spaceBetween: vm.config.spaceBetween || 32,
        slidesPerView: vm.config.slidesPerView || 1,
        breakpoints: vm.config.breakpoints || {},
        navigation: {
          nextEl: vm.$refs.nextButton,
          prevEl: vm.$refs.prevButton
        },
        lazy: {
          enabled: true,
          loadPrevNext: true
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true
        },
        on: {
          beforeInit: function (mainSwiper) {
            vm.totalSlides = this.el.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;

            // Disable buttons if there are only two slides
            if (vm.totalSlides <= 2) {
              const prevButton = document.querySelector(".js-carousel-prev-nav");
              const nextButton = document.querySelector(".js-carousel-next-nav");

              if (prevButton) prevButton.setAttribute("disabled", "disabled");
              if (nextButton) nextButton.setAttribute("disabled", "disabled");
            }

            Object.keys(mainSwiper.params.breakpoints).forEach((breakpoint) => {
              if (mainSwiper.params.breakpoints[breakpoint]) {
                if (mainSwiper.params.breakpoints[breakpoint].slidesPerView >= vm.totalSlides) {
                  // eslint-disable-next-line no-param-reassign
                  mainSwiper.params.breakpoints[breakpoint].slidesPerView = vm.totalSlides;
                  // eslint-disable-next-line no-param-reassign
                  mainSwiper.params.breakpoints[breakpoint].slidesPerGroup = vm.totalSlides;
                }
              }
            });
          },
          breakpoint(mainSwiper, breakpointParams) {
            if (breakpointParams.slidesPerView >= vm.totalSlides) {
              // console.log('Disabling Carousel');
              mainSwiper.disable();
              vm.disabled = true;
            } else {
              // console.log('Enabling Carousel');
              mainSwiper.enable();
              vm.disabled = false;
            }

            if (breakpointParams.disabled) {
              mainSwiper.disable();
              vm.disabled = true;
            } else {
              mainSwiper.enable();
              vm.disabled = false;
            }
          },
          resize: function (mainSwiper) {
            const minWeight = window.innerWidth;
            if (minWeight <= 400) {
              this.isMobileView = true;
              // console.log(this.isMobileView, '1');
            } else {
              // console.log(this.isMobileView, '2');
              this.isMobileView = false;
            }
            // console.log('realIndex', mainSwiper.slides.length);
            // console.log('loopedSlides', mainSwiper.loopedSlides);
            // console.log(vm.totalSlides);
          },
          progress: (mainSwiper, progress) => {
            const wrapper = mainSwiper.el.closest('[data-alpine-component="carousel"]');
            const nextNavBtns = Array.from(wrapper.querySelectorAll(".js-carousel-next-nav"));
            const prevNavBtns = Array.from(wrapper.querySelectorAll(".js-carousel-prev-nav"));

            if (progress === 0) {
              prevNavBtns.forEach((btn) => {
                btn.setAttribute("disabled", "");
              });
            } else if (progress >= 1) {
              nextNavBtns.forEach((btn) => {
                btn.setAttribute("disabled", "");
              });
            } else {
              nextNavBtns.forEach((btn) => {
                btn.removeAttribute("disabled");
              });

              prevNavBtns.forEach((btn) => {
                btn.removeAttribute("disabled");
              });
            }
          }
        }
      });
      swiperMain.on("slideNextTransitionStart", (swiper) => {
        // console.log('moving to next slide');
        if (window.lazyload) {
          window.lazyload.update();
        }
      });
      swiperMain.on("slideNextTransitionEnd", (swiper) => {
        // console.log('moving to next slide');
        if (window.lazyload) {
          window.lazyload.update();
        }
      });

      vm.mainSlider = swiperMain;
    },
    moveToNextSlide() {
      // console.log('moving to next slide');
      this.mainSlider.slideNext();
      if (window.lazyload) {
        window.lazyload.update();
      }
    },
    moveToPrevSlide() {
      // console.log('moving to prev slide');
      this.mainSlider.slidePrev();
      if (window.lazyload) {
        window.lazyload.update();
      }
    },
    moveToSlide(slideNumber) {
      // console.log('moving to slide: ', slideNumber);
      this.mainSlider.slideTo(slideNumber);
    }
  };
}
